const PRODUCT_CONFIG = {
  credit_boost: {
    pillColor: "bg-black",
    fontColor: "text-white",
    label: "boost",
  },
  credit_card: {
    pillColor: "bg-green-primary",
    fontColor: "text-white",
    label: "credit card",
  },
  credit_monitoring: {
    pillColor: "bg-green-secondary",
    fontColor: "text-black",
    label: "credit monitoring",
  },
  other: {
    pillColor: "bg-fog-gray",
    fontColor: "text-black",
    label: undefined,
  },
};

export default PRODUCT_CONFIG;
